import PageLayout from "./PageLayout";
import {Button} from "../general/input/Button";
import {request} from "../../res/rest/restRequest";
import axios from "axios";
import {api} from "../../res/rest/api";
import {useSelector} from "react-redux";
import {env} from "../../res/config/env";

const PageTest = () => {

    const {
        session
    } = useSelector(state => state.auth);

    const runTest = async () => {
        const req = request.model("c_order").id("a30f5f24-e185-4a9e-ae4b-d1ff3efb6c5c");
        const url = req.buildRequest(env.API_URL);
        axios.put(url, { "IsConfirmed": "true" }, api.auth(session))
            .then(r => console.log(r.data.IsConfirmed))
            .catch(e => console.log(e));
    }

    return (
        <PageLayout>
            <div>
                <Button
                    style={{
                        height: "300px",
                        width: "70vw",
                        margin: "100px auto",
                        textAlign: "center",
                        display: "flex"
                    }}
                    onClick={runTest}>
                    <p style={{
                        margin: "auto auto",
                        fontSize: "10em"
                    }}>Test</p>
                </Button>
            </div>
        </PageLayout>
    )

}

export default PageTest;